import {
  AiOutlineStar,
  AiOutlineLineChart,
  AiOutlineAppstoreAdd,
  AiOutlineUser,
  AiOutlineExpandAlt,
  AiOutlineLock
} from "react-icons/ai";

export const cards = [
  {
    title: "AI Personalization",
    description:
      "AI-driven personalization enhances user engagement with unique experiences.",
    icon: <AiOutlineStar />
  },
  {
    title: "Real-Time Insights",
    description:
      "Utilize our analytics for instant insights on user behavior and app performance.",
    icon: <AiOutlineLineChart />
  },
  {
    title: "Seamless SDK Integration",
    description:
      "Effortlessly integrate with our robust, cross-platform SDKs for maximum compatibility.",
    icon: <AiOutlineAppstoreAdd />
  },
  {
    title: "Dynamic Content",
    description:
      "Keep content engaging with AI-powered optimization, adapting to user preferences.",
    icon: <AiOutlineUser />
  },
  {
    title: "Highly Scalable",
    description:
      "Quest's scalable solutions ensure seamless growth without performance compromise.",
    icon: <AiOutlineExpandAlt />
  },
  {
    title: "Robust Security",
    description:
      "Quest ensures security with data protection, compliance, and secure transactions.",
    icon: <AiOutlineLock />
  }
];
